// utils/metaCookies.js
export function readCookie(name) {
  if (typeof document === "undefined") return null; // SSR guard
  return (
    document.cookie
      ?.split("; ")
      .find((row) => row.startsWith(name + "="))
      ?.split("=")[1] || null
  );
}

export function getCapiMeta() {
  const _fbp = readCookie("_fbp");
  const _fbc = readCookie("_fbc");
  const eventSourceUrl =
    typeof window !== "undefined" ? window.location.href : null;

  return { _fbp: _fbp || null, _fbc: _fbc || null, eventSourceUrl };
}
